export default "__VITE_ASSET__GXVUnKzg__"